export{useDynamicDeliveryEstimation}from"./hooks/use-dynamic-delivery-estimation.js";
//# sourceMappingURL=index.js.map
